import React, { useMemo } from 'react';
import { useStoreState } from 'easy-peasy';
import { NavLink, useParams } from 'react-router-dom';
import { useJobProgressSegment } from '@components/navigation/JobProgressSwitch/_hooks/use-job-progress-segment';

import { Icon } from '@reverse-hr/design-system';
import {
  jobProgressSelector,
  jobStoreSelector,
  selectorJobIsReverseMarketing,
} from '@model/Job/Job.selectors';

const Stepper = ({ modifier = '', steps = [], onRouteChange }) => {
  const job = useStoreState(jobStoreSelector) || {};
  const jobProgress = useStoreState(jobProgressSelector);
  const isJobReverseMarketing = useStoreState(selectorJobIsReverseMarketing);
  const { entityType, entityId: jobId } = useParams();
  const segment = useJobProgressSegment();

  const getMappedSteps = steps => {
    let currentIndex = 0;
    steps.forEach((s, i) => {
      if (s.name === jobProgress) {
        currentIndex = i;
      }
    });

    return steps.map((step, index) => {
      const current = step.name === segment;
      const done = job.closedAt || index < currentIndex;

      return {
        ...step,
        url: `/${entityType}/${jobId}/${step.name}`,
        icon: step.icon,
        done,
        current,
      };
    });
  };
  const mappedSteps = useMemo(
    () =>
      getMappedSteps(steps).filter(step =>
        job.isShowcaseEnabled ? step : step.name !== 'showcase',
      ),
    [steps, job.isShowcaseEnabled],
  );

  const handleAnalytics = step => {
    onRouteChange(step);
  };

  return (
    <div className={`c-app-stepper ${modifier}`}>
      <ul className="c-app-stepper__list">
        {mappedSteps.map((step, index) => {
          const active = step.name === segment;
          return (
            <NavLink
              data-testid={`stepper-step-link-${index}`}
              key={`stepper-link-${index}`}
              to={step.url}
              onClick={() => handleAnalytics(step)}
            >
              <li
                key={`step-${index}`}
                className={`c-app-stepper__label ${
                  active ? 'c-app-stepper__label--active' : ''
                } ${!active && step.done ? 'c-app-stepper__label--done' : ''}`}
              >
                <div className="c-app-stepper__anchor">
                  <span
                    data-testid={`stepper-step-icon-${index}`}
                    className="c-app-stepper__icon"
                  >
                    <Icon size={20} name={step.icon} />
                  </span>
                  <div>
                    <p
                      data-testid={`stepper-step-title-${index}`}
                      className="c-app-stepper__primary-text"
                    >
                      {step.title}
                    </p>

                    {isJobReverseMarketing ? null : (
                      <p
                        data-testid={`stepper-step-description-${index}`}
                        className="c-app-stepper__secondary-text"
                      >
                        {step.description}
                      </p>
                    )}
                  </div>
                </div>
              </li>
            </NavLink>
          );
        })}
      </ul>
    </div>
  );
};

export default Stepper;
